import { createRouter, createWebHistory } from 'vue-router'
import { storeToRefs } from 'pinia'

import ProjectIndexView from '@/views/projects/ProjectIndexView.vue'
import ProjectDetailView from '@/views/projects/ProjectDetailView.vue'
import UserManagementView from '@/views/projects/UserManagementView.vue'
import CalculationIndexView from '@/views/projects/CalculationIndexView.vue'
import CalculationDetailView from '@/views/calculations/CalculationDetailView.vue'
import CalculationResultView from '@/views/calculations/CalculationResultView.vue'
import CalculationFormView from '@/views/calculations/CalculationFormView.vue'
import NotFoundView from '@/views/NotFoundView.vue'

import { authRoutes } from '@haskoning/vue-authentication-middleware'
import { useProjectStore } from '@/stores/project'
import { useDjangoAuthStore } from '@/stores/authDjango'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: NotFoundView
    },
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'auth-login'
      }
    },
    authRoutes,
    {
      path: '/project-index',
      name: 'project-index',
      component: ProjectIndexView,
      beforeEnter: () => {
        const store = useProjectStore()
        store.resetAll()
        return true
      }
    },
    {
      path: '/project/:id',
      name: 'project-detail',
      component: ProjectDetailView,
      redirect: {
        name: 'calculation-index'
      },
      children: [
        {
          path: '/project/:id',
          name: 'calculation-index',
          component: CalculationIndexView
        },
        {
          path: '/project/:id/user-management',
          name: 'user-management',
          component: UserManagementView
        }
      ]
    },
    {
      path: '/project/:id/calculation/:calculationId',
      name: 'calculation-detail',
      component: CalculationDetailView,
      redirect: {
        name: 'calculation-result'
      },
      children: [
        {
          path: '/project/:id/calculation/:calculationId/form',
          name: 'calculation-form',
          component: CalculationFormView
        },
        {
          path: '/project/:id/calculation/:calculationId/result',
          name: 'calculation-result',
          component: CalculationResultView
        }
      ]
    }
  ]
})

router.beforeEach(async (to) => {
  const authStore = useDjangoAuthStore()
  const { user } = storeToRefs(authStore)

  if (!user?.value?.id) {
    const userResponse = await authStore.reAuthenticate()
    if (userResponse) {
      authStore.user = userResponse.user
    }
  }
  if (to.name && typeof to.name === 'string' && to.name.startsWith('auth-')) {
    if (user.value) {
      return { name: 'project-index' }
    }
    return true
  }
  // check auth and apply login redirect
  if (!user.value) {
    authStore.loginRedirect = to.fullPath
    return { name: 'auth-login' }
  }
  return true
})

export default router
